import { DashboardLayout } from "@/projects/components/dashboard-layout";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/projects/components/ui/table";
import { StatusBadge } from "@/projects/components/status-badge";
import {
  DataPagination,
  useServerPagination,
} from "@/projects/components/data-pagination";
import {
  fetchVerificationHistoryPage,
  getSubmissionApiErrorMessage,
} from "@/projects/lib/submissionsApi";
import { Loader2 } from "lucide-react";
import { toast } from "@/projects/lib/toast";

export function TeacherHistoryPage() {
  const pagination = useServerPagination(
    ({ page, pageSize }) => fetchVerificationHistoryPage({ page, pageSize }),
    [],
    {
      onError: error =>
        toast.error(
          getSubmissionApiErrorMessage(
            error,
            "Failed to load verification history."
          )
        ),
    }
  );
  const rows = pagination.items;
  const loading = pagination.loading;

  return (
    <DashboardLayout
      role="teacher"
      title="Verification History"
      breadcrumb={["Home", "History"]}
    >
      <div className="bg-card shadow-soft overflow-hidden rounded-xl border">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead>Reference</TableHead>
                <TableHead>Student</TableHead>
                <TableHead>Title</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Verified</TableHead>
                <TableHead>Remarks</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={6} className="py-16 text-center">
                    <div className="text-muted-foreground inline-flex items-center gap-2 text-sm">
                      <Loader2 className="h-4 w-4 animate-spin" />
                      Loading history…
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {!loading && rows.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    className="text-muted-foreground py-10 text-center text-sm"
                  >
                    No verification history yet.
                  </TableCell>
                </TableRow>
              )}
              {!loading &&
                rows.map(row => (
                  <TableRow key={row.id}>
                    <TableCell className="text-royal font-mono text-xs">
                      {row.reference}
                    </TableCell>
                    <TableCell className="font-medium">{row.student}</TableCell>
                    <TableCell className="max-w-[220px] truncate">
                      {row.title}
                    </TableCell>
                    <TableCell>
                      <StatusBadge status={row.status} />
                    </TableCell>
                    <TableCell className="text-muted-foreground text-xs">
                      {row.verified
                        ? new Date(row.verified).toLocaleString()
                        : "—"}
                    </TableCell>
                    <TableCell className="text-muted-foreground max-w-[280px] text-xs">
                      {row.remarks || "—"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
        {!loading && rows.length > 0 && (
          <DataPagination pagination={pagination} itemLabel="records" />
        )}
      </div>
    </DashboardLayout>
  );
}
